/**
 * @mynaui/icons-react v0.3.1 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var BrandFigma = createReactComponent("brand-figma", "BrandFigma", [["path", { "d": "M6 12a3 3 0 0 1 3-3h3v6H9a3 3 0 0 1-3-3m0 6a3 3 0 0 1 3-3h3v3a3 3 0 0 1-6 0", "key": "svg-0" }], ["path", { "d": "M12 12a3.001 3.001 0 0 1 5.121-2.121A3.001 3.001 0 1 1 12.001 12", "key": "svg-1" }], ["path", { "d": "M12 3h3a3 3 0 0 1 0 6h-3zM6 6a3 3 0 0 1 3-3h3v6H9a3 3 0 0 1-3-3", "key": "svg-2" }]]);

export { BrandFigma as default };
//# sourceMappingURL=BrandFigma.js.map
